import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { reportContents, walkthrough } from '../../data/content';
export function Walkthrough() {
  return <section className="w-full bg-ink py-16 sm:py-24" data-id="element-367" data-mp="1d7qbdjfmcruc">
      <div className="mx-auto max-w-6xl px-4" data-id="element-368" data-mp="1hzzv2hq54vo6">
        <SectionHeading kicker="See how the No-Start Diagnostic Pathway™ works" title={<>Your next customer’s vehicle <span className="text-brand" data-id="element-370" data-mp="1rxnrrd7b4d8z">cranks but won’t start.</span></>} subtitle="Instead of immediately suspecting the fuel pump, ignition coil, or crankshaft sensor, you follow a structured investigation." data-id="element-369" data-mp="1i1uhy1kz2xuw" />

        <div className="mt-12 grid gap-10 lg:grid-cols-[1.4fr_1fr] lg:items-start" data-id="element-371" data-mp="20xklht8k02aw">
          <ol className="space-y-4" data-id="element-372" data-mp="2jhovaae360t">
            {walkthrough.map((step, i) => <li key={step.title} className="flex gap-4 border-b border-line pb-4 last:border-0" data-id="element-373" data-mp="6kb7pp8z5umu" data-mpi={i}>
                <span className="font-display text-4xl font-black leading-none text-brand" data-id="element-374" data-mp="1qv9covxb6sbj">{i + 1}</span>
                <div data-id="element-375" data-mp="1m49ezogd867z">
                  <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-376" data-mp="1m3rkoxd9k22p">{step.title}</h3>
                  <div className="mt-1.5 space-y-1 text-base leading-relaxed text-body" data-id="element-377" data-mp="1h67z1ce8kn0q">
                    {step.lines.map(l => <p key={l} data-id="element-378" data-mp="29udf3luchnu8">{l}</p>)}
                  </div>
                </div>
              </li>)}
          </ol>

          <div className="rounded-3xl border-2 border-brand bg-panel p-6 lg:sticky lg:top-6" data-id="element-379" data-mp="24vtuppvegk3z">
            <p className="font-display text-3xl font-black uppercase leading-tight text-white" data-id="element-380" data-mp="1zuwbrb2kfm1f">
              Your result: <span className="text-brand" data-id="element-381" data-mp="1uwl6zer4o1q2">one organized diagnostic record.</span>
            </p>
            <p className="mt-3 text-base text-body" data-id="element-382" data-mp="oilt3xhjd6ap">
              Instead of a scattered collection of observations, you have a structured report containing:
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-383" data-mp="37oxyynoxd6pk">
              {reportContents.map(r => <li key={r} className="flex items-start gap-2.5 text-base font-medium text-white" data-id="element-384" data-mp="3bprplotr4zm5">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-385" data-mp="2xqi6ohe5vreh" />
                  {r}
                </li>)}
            </ul>
            <p className="mt-5 text-sm text-muted" data-id="element-386" data-mp="2nzdt9m44welr">
              The system doesn’t promise that every fault will be identified in a fixed amount of time. It gives you a repeatable
              process for investigating the problem.
            </p>
          </div>
        </div>

        <CtaButton className="mt-12" label="Build My First Diagnostic Record" data-id="element-387" data-mp="2jybs2zqnpsh5" />
      </div>
    </section>;
}